import { http } from '@/services/http';

/**
 * PDF + XLS exports for a completed survey.
 *
 * The Rails routes are `/api/pdf/:survey_id` and `/api/xls/:survey_id` (see
 * config/routes.rb), where `:survey_id` is actually the survey's **GUID** —
 * the controllers look up via `Survey.where(guid: params[:survey_id])` and
 * are intentionally unauthenticated (the GUID is the auth token). Pass
 * `survey.guid`, not `survey.id`.
 */
export const exportsApi = {
  pdf(guid: string): Promise<ArrayBuffer> {
    return http<ArrayBuffer>({
      url: `pdf/${guid}`,
      method: 'get',
      responseType: 'arraybuffer',
    });
  },
  xls(guid: string): Promise<ArrayBuffer> {
    return http<ArrayBuffer>({
      url: `xls/${guid}`,
      method: 'get',
      responseType: 'arraybuffer',
    });
  },
};
